import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=263d72ec&scoped=true"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d72ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263d72ec')) {
      api.createRecord('263d72ec', component.options)
    } else {
      api.reload('263d72ec', component.options)
    }
    module.hot.accept("./AlertDetails.vue?vue&type=template&id=263d72ec&scoped=true", function () {
      api.rerender('263d72ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/AlertDetails.vue"
export default component.exports